function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import PropTypes from "prop-types";
import { withProvider, consumeContext } from "./PlayerContext";
import Video from "./Video";
import Logo from "./Logo";

var Player = function (_Component) {
  _inherits(Player, _Component);

  function Player(props) {
    _classCallCheck(this, Player);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.pause = function () {
      return _this.player.pause();
    };

    props.playerRef && props.playerRef(_this);
    return _this;
  }

  Player.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        PlayerContext = _props.PlayerContext,
        rest = _objectWithoutProperties(_props, ["PlayerContext"]);

    PlayerContext.initializeState(rest);
  };

  Player.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        startTime = _props2.startTime,
        autoPlay = _props2.autoPlay,
        logo = _props2.logo,
        frameSource = _props2.frameSource,
        poster = _props2.poster;
    var _props$PlayerContext$ = this.props.PlayerContext.state,
        videoState = _props$PlayerContext$.videoState,
        scale = _props$PlayerContext$.scale;
    return React.createElement(Video, {
      playerRef: function playerRef(player) {
        return _this2.player = player;
      },
      style: {
        width: "100%",
        height: "100%"
      },
      autoPlay: autoPlay,
      startTime: startTime,
      frameSource: frameSource,
      poster: poster
    }, logo && React.createElement(Logo, {
      logo: logo,
      videoState: videoState,
      scale: scale
    }), this.props.children);
  };

  return Player;
}(Component);

Player.propTypes = process.env.NODE_ENV !== "production" ? {
  PlayerContext: PropTypes.object.isRequired,
  videoSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  overlay: PropTypes.object,
  autoPlay: PropTypes.bool,
  autoHideControlBar: PropTypes.bool,
  disableControlBarControls: PropTypes.bool,
  startTime: PropTypes.number,
  onResize: PropTypes.func,
  onScaleChange: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onVideoPropsReceived: PropTypes.func,
  onTimeChanged: PropTypes.func,
  children: PropTypes.any,
  logo: PropTypes.shape({
    url: PropTypes.string.isRequired,
    size: PropTypes.string,
    bottom: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number,
    left: PropTypes.number
  }),
  frameSource: PropTypes.string,
  playerRef: PropTypes.func,
  poster: PropTypes.string
} : {};
export default withProvider(consumeContext(Player));